import { render, staticRenderFns } from "./PaginaNoEncontrada.vue?vue&type=template&id=1c96009d&"
import script from "./PaginaNoEncontrada.vue?vue&type=script&lang=js&"
export * from "./PaginaNoEncontrada.vue?vue&type=script&lang=js&"
import style0 from "./PaginaNoEncontrada.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports